import { SET_IS_FORM_DISABLED } from '../actionsTypes';

export const setIsFormDisabled = (isFormDisabled) => async (dispatch) => {
  dispatch({
    type: SET_IS_FORM_DISABLED,
    payload: { isFormDisabled },
  });
};
